import { format } from 'date-fns';
import styles from './styles.module.css';

type Props = {
  value: Date;
};

function LastCalculatedAt({ value }: Props) {
  const s = format(value, 'yyyy/M/d H:mm:ss');
  return <div className={styles.lastCalculatedAt}>{`計算更新日時 : ${s}`}</div>;
}

export default LastCalculatedAt;
